import { ICreateMediaItem } from "@interfaces/createMediaItem";
import { getUnixTime } from "date-fns";
import TCreateEditMedia from "types/Media/createEditMedia";

const mediaItemMapper = (formValues: any): TCreateEditMedia => ({
  title: formValues.title,
  date: getUnixTime(formValues.date),
  type: formValues.type.value,
  gallery:
    Array.isArray(formValues.gallery) &&
    formValues.gallery.every((item: ICreateMediaItem) =>
      item.hasOwnProperty("mediaUrl")
    )
      ? formValues.gallery
      : typeof formValues.gallery === "string"
      ? [{ mediaUrl: formValues.gallery }]
      : undefined,
  galleryFilesForDelete: formValues.galleryFilesForDelete,
});

export default mediaItemMapper;
